import { useBusinessSettingsContext } from '../../hooks/useBusinessSettingsContext'
import Help from '../Help'
import FashionContact from '../../storefronts/indumentaria-femenina/FashionContact'

function PublicContact() {
  const { activeProfile, loading } = useBusinessSettingsContext()

  if (loading && !activeProfile) {
    return null
  }

  if (activeProfile?.rubro === 'indumentaria' && (activeProfile?.subrubro || 'femenina') === 'femenina') {
    return <FashionContact />
  }

  return <Help />
}

export default PublicContact
